/**
 * 汎用モーダルシステム
 * READMEのオーバーレイ統一仕様に準拠
 * 
 * 使い方:
 * - data-modal-open="modal-id" : モーダルを開くトリガー
 * - data-modal-close="modal-id" : モーダルを閉じるボタン
 * - data-modal-overlay="modal-id" : オーバーレイ（overlay-baseクラス必須）
 * - id="modal-id" : モーダル本体
 */

class ModalSystem {
  constructor() {
    this.openButtons = document.querySelectorAll('[data-modal-open]');
    this.closeButtons = document.querySelectorAll('[data-modal-close]');
    this.overlays = document.querySelectorAll('[data-modal-overlay]');
    this.openModalsCount = 0; // 開いているモーダルの数を追跡
    this.init();
  }

  init() {
    this.bindOpenEvents();
    this.bindCloseEvents();
    this.bindOverlayEvents();
  }

  // モーダルを開く
  open(modalId) {
    const modal = document.getElementById(modalId);
    const overlay = document.querySelector(`[data-modal-overlay="${modalId}"]`);

    if (!modal || !overlay) {
      console.warn(`Modal or overlay not found: ${modalId}`);
      return;
    }

    modal.style.display = 'block';
    // トランジション用に少し遅延
    setTimeout(() => {
      overlay.classList.add('is-visible');
      modal.classList.add('is-visible');
    }, 10);

    // 背景のスクロールを防ぐ
    this.openModalsCount++;
    if (this.openModalsCount === 1) {
      document.body.style.overflow = 'hidden';
    }
  }

  // モーダルを閉じる
  close(modalId) {
    const modal = document.getElementById(modalId);
    const overlay = document.querySelector(`[data-modal-overlay="${modalId}"]`);

    if (!modal || !overlay) {
      console.warn(`Modal or overlay not found: ${modalId}`);
      return;
    }

    overlay.classList.remove('is-visible');
    modal.classList.remove('is-visible');
    
    // トランジション完了後に非表示
    setTimeout(() => {
      modal.style.display = 'none';
    }, 300);

    // すべてのモーダルが閉じたら背景のスクロールを復元
    this.openModalsCount--;
    if (this.openModalsCount <= 0) {
      this.openModalsCount = 0;
      document.body.style.overflow = '';
    }
  }

  // 開くボタンのイベント
  bindOpenEvents() {
    this.openButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = button.dataset.modalOpen;
        this.open(modalId);
      });
    });
  }

  // 閉じるボタンのイベント
  bindCloseEvents() {
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const modalId = button.dataset.modalClose;
        this.close(modalId);
      });
    });
  }

  // オーバーレイクリックで閉じる
  bindOverlayEvents() {
    this.overlays.forEach((overlay) => {
      overlay.addEventListener('click', (e) => {
        // クリックされた要素がオーバーレイ自身の場合のみ閉じる
        if (e.target === overlay) {
          const modalId = overlay.dataset.modalOverlay;
          this.close(modalId);
        }
      });
    });
  }

  // 動的に追加されたモーダルにも対応
  refresh() {
    this.openButtons = document.querySelectorAll('[data-modal-open]');
    this.closeButtons = document.querySelectorAll('[data-modal-close]');
    this.overlays = document.querySelectorAll('[data-modal-overlay]');
    this.init();
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  window.modalSystem = new ModalSystem();
});

// 動的コンテンツ用のリフレッシュメソッドを公開
window.refreshModalSystem = () => {
  if (window.modalSystem) {
    window.modalSystem.refresh();
  }
};
